import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useDownloadExcel } from "react-export-table-to-excel";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { useQuery } from "@apollo/client";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
//Import from project
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { currencyFormat, currencyFormatRiel } from "../../Function/DynamicFn";
import { GET_CHART_OF_ACCOUNT_FOR_SELECT } from "../../Schema/SelectSchema";
import { GET_SUPPLIER_WITH_PAGINATION } from "../../Schema/Supplier";
import { GET_DISBURESMENT_REPORT } from "../../Schema/Report";
import school from "../../Assets/goglobal-school.png";
import symbol from "../../Assets/tacteing.jpg";
import ExportDisbursement from "./ExportDisbursement";

export default function DisburmentReport() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [fromDate, setFromDate] = useState(moment().startOf("month"));
  const [toDate, setToDate] = useState(moment());
  const [fromDisbursementNumber, setFromDisbursementNumber] = useState(null);
  const [toDisbursementNumber, setToDisbursementNumber] = useState(null);

  // ================================== Export to excel =====================================
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Debursement-Report",
    sheet: "Debursement-Report",
  });
  // =================== Export to excel school fee ===================
  const [checkExport, setCheckExport] = useState(false);
  const handleExportExcel = () => {
    setCheckExport(true);
    setTimeout(() => {
      onDownload();
      setCheckExport(false);
    }, 2000);
  };

  // ================== Account Type ====================
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [selectedVal, setSelectedVal] = useState(null);

  const { refetch: refetchAccount } = useQuery(
    GET_CHART_OF_ACCOUNT_FOR_SELECT,
    {
      onCompleted: ({ getChartOfAccountForSelect }) => {
        let rows = [{ id: "Create", title: "New chart of account" }];
        if (getChartOfAccountForSelect?.length !== 0) {
          getChartOfAccountForSelect.forEach((d) => {
            rows.push({
              id: d?._id,
              title: `${d?.code_account} - ${d?.chartOfAccount}`,
            });
          });
          setAccountTypeOptions(rows);
        } else {
          setAccountTypeOptions([]);
        }
      },
    }
  );

  useEffect(() => {
    refetchAccount();
  }, [refetchAccount]);

  const handleSelect = (val) => {
    setSelectedVal(val);
  };

  // ============================== Select Supplier ============================
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [selectSupplier, setSelectSupplier] = useState(null);

  const { refetch: refetchSupplier } = useQuery(GET_SUPPLIER_WITH_PAGINATION, {
    variables: {
      page: 1,
      limit: 500,
      keyword: "",
    },
    onCompleted: ({ getSupplierPagination }) => {
      // console.log("getSupplierPagination", getSupplierPagination);
      if (getSupplierPagination?.data) {
        let rows = [{ id: "Create", title: "New Supplier" }];
        getSupplierPagination?.data?.map((e) => {
          const allRow = {
            id: e?._id,
            title: e?.name,
          };
          rows.push(allRow);
        });
        setSupplierOptions(rows);
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });
  useEffect(() => {
    refetchSupplier();
  }, [refetchSupplier]);

  const handleSelectSupplier = (val) => {
    setSelectSupplier(val);
  };

  //======================================= Get disbursement ==============================================
  const { refetch: refetchDisburment } = useQuery(GET_DISBURESMENT_REPORT, {
    variables: {
      fromDisNum: fromDisbursementNumber ? parseInt(fromDisbursementNumber) : null,
      toDisNum: toDisbursementNumber ? parseInt(toDisbursementNumber) : null,
      fromDate: fromDate ? moment(fromDate)?.format("YYYY-MM-DD") : "",
      toDate: toDate ? moment(toDate)?.format("YYYY-MM-DD") : "",
      accountId: selectedVal?.id ? selectedVal?.id : null,
      supplierId: selectSupplier?.id ? selectSupplier?.id : null,
    },
    onCompleted: ({ getDisbursementReport }) => {
      setTableData(getDisbursementReport);
      setLoading(false);
    },
    onError:(error)=>{
      // console.log(error, "Err disbursment report");
    }
  });

  let largestPayments = tableData[0];

  for (const item of tableData) {
    if (item?.payments?.length > largestPayments?.payments?.length) {
      largestPayments = item;
    }
  }

  useEffect(() => {
    console.log("refetchDisburment...");
    refetchDisburment();
  }, [fromDisbursementNumber, toDisbursementNumber, fromDate, toDate, selectedVal?.id, selectSupplier?.id]);

  const { totalPriceKHR, totalPriceUSD } = tableData.reduce(
    (acc, e) => {
      e?.disburmentList?.forEach((f) => {
        acc.totalPriceKHR += f.priceKHR || 0;
        acc.totalPriceUSD += f.priceUSD || 0;
      });
      return acc;
    },
    { totalPriceKHR: 0, totalPriceUSD: 0 }
  );

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="row" spacing={2}>
          <Box className="slash" />
          <Stack direction="column" justifyContent="center">
            <Link to="/report" className="page-link-title">
              <Typography className="page-title">Report</Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">Disbursement</Typography>
          </Stack>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              Cash Receiving Voucher
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container rowSpacing={1} columnSpacing={3}>
          <Grid item xs={2} sm={2} md={3} lg={1.7} xl={1.7}>
            <Typography className="search-head-title">From Disbursement Number</Typography>
            <TextField
                placeholder="Disbursement number"
                size="small"
                type="number"
                className="search-field"
                onChange={(e) => setFromDisbursementNumber(e.target.value)}
                InputProps={{
                  // startAdornment: (
                  //   <InputAdornment position="start" sx={{ mr: 1 }}>
                  //     <SearchIcon />
                  //   </InputAdornment>
                  // ),
                }}
              />
          </Grid>
          <Grid item xs={2} sm={2} md={3} lg={1.7} xl={1.7}>
            <Typography className="search-head-title">To Disbursement Number</Typography>
            <TextField
                placeholder="Disbursement number"
                size="small"
                type="number"
                className="search-field"
                onChange={(e) => setToDisbursementNumber(e.target.value)}
                InputProps={{
                  // startAdornment: (
                  //   <InputAdornment position="start" sx={{ mr: 1 }}>
                  //     <SearchIcon />
                  //   </InputAdornment>
                  // ),
                }}
              />
          </Grid>
          <Grid item xs={2} sm={2} md={3} lg={1.7} xl={1.7}>
            <Typography className="search-head-title">From</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={fromDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setFromDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={2} sm={2} md={3} lg={1.7} xl={1.7}>
            <Typography className="search-head-title">To</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={toDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={2} sm={2} md={3} lg={1.7} xl={1.7}>
            <Typography className="search-head-title">Account Type</Typography>

            <Autocomplete
              sx={{ width: "300px" }}
              className="search-field"
              size="small"
              placeholder="expense type"
              disablePortal
              options={accountTypeOptions}
              value={selectedVal}
              onChange={(event, val) => handleSelect(val)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              getOptionLabel={(option) => (option.title ? option.title : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="disbursement-field"
                  size="small"
                  placeholder="expense type"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={1.7} xl={1.7}>
            <Typography className="search-head-title">Supplier</Typography>
            <Autocomplete
              sx={{ width: "300px" }}
              className="search-field"
              size="small"
              placeholder="supplier"
              disablePortal
              options={supplierOptions}
              value={selectSupplier}
              onChange={(event, val) => handleSelectSupplier(val)}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              getOptionLabel={(option) => (option.title ? option.title : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="disbursement-field"
                  size="small"
                  placeholder="supplier"
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={1.7} xl={1.7}>
            <Stack direction="row" justifyContent="right">
              <Button
                className="btn-create"
                onClick={handleExportExcel}
                startIcon={
                  <SiMicrosoftexcel style={{ height: "18px", width: "18px" }} />
                }
              >
                Export
              </Button>

              <ExportDisbursement
                loading={loading}
                tableData={tableData}
                tableRef={tableRef}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ marginTop: "20px" }}>
        <Box
          sx={{ bgcolor: "#fff", borderRadius: "10px" }}
          className="dibursement-print-container"
        >
          <Grid container>
            <Grid item xs={3}>
              <Stack direction="column">
                <img src={school} alt="school" className="logo-size" />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack direction="column">
                <Stack justifyContent="center" alignItems="center">
                  <Typography className="disbursement-title-kh">
                    ព្រះរាជាណាចក្រកម្ពុជា
                  </Typography>
                  <Typography className="disbursement-title">
                    Kingdom Of Cambodia
                  </Typography>
                  <Typography className="disbursement-title-kh">
                    ជាតិ សាសនា ព្រះមហាក្សត្រ
                  </Typography>
                  <Typography className="disbursement-title">
                    Nation Region King
                  </Typography>
                  <img src={symbol} alt="" width="140px" />
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
          {/* <Stack
            direction="row"
            width="100%"
            justifyContent="right"
            spacing={3}
          >
            <Typography className="number-text">លេខ ៖</Typography>
            <Typography className="number-text">026 / 24</Typography>
          </Stack> */}

          <Stack direction="column" justifyContent="center" alignItems="center">
            <Typography className="disbursement-table-title">
              របាយការណ៍ចំណាយ
            </Typography>
            <Typography className="disbursement-table-title-eng">
              Disbursement Report
            </Typography>
          </Stack>
          <Box sx={{ marginTop: "10px" }} justifyContent="center">
            <table className="table-cash">
              <thead className="thead-cash">
                <tr>
                  <td className="title-table">កាលបរិច្ឆេទ</td>
                  <td className="title-table">លេខរៀង</td>
                  <td className="title-table">លេខវិក័យបត្រ</td>
                  <td className="title-table">អ្នកផ្គត់ផ្គង់</td>
                  <td className="title-table">ប្រភេទទំនិញ</td>
                  <td className="title-table">ចំនួន</td>
                  <td className="title-table">អត្រាប្តូរប្រាក់</td>
                  <td className="title-table">សរុបដុល្លា</td>
                  <td className="title-table">រៀល</td>
                  <td className="title-table">ដុល្លា</td>
                  {/* {tableData?.length === 0 ||
                  largestPayments?.payments === 0 ? null : (
                    <>
                      {largestPayments?.payments?.map((head, index) => {
                        return (
                          <Fragment key={index}>
                            <td className="title-table">លេខស្នើរលុយ</td>
                            <td className="title-table">ការទូទាត់</td>
                            <td className="title-table">ថ្ងៃទូទាត់</td>
                            <td className="title-table">ខែទូទាត់</td>
                          </Fragment>
                        );
                      })}
                    </>
                  )} */}
                  <td className="title-table">ប្រភេទចំណាយ</td>
                </tr>
              </thead>

              <tbody className="tbody-cash">
                {tableData?.map((row, index) => {
                  // console.log("row::", row);
                  return (
                    <tr key={index}>
                      <td className="title-table">
                        {moment(row?.date)?.format("DD-MMM-yyyy")}
                      </td>
                      <td className="title-table">{row?.disbursementNumber}</td>
                      <td className="title-table">{row?.InvoiceNo}</td>
                      <td className="title-table">{row?.supplier}</td>
                      <td className="title-table">{row?.description}</td>
                      <td className="title-table">{row?.qty}</td>
                      <td
                        className="title-table"
                        align="right"
                        style={{ color: "purple" }}
                      >
                        {currencyFormatRiel(parseFloat(row?.exchangeRate))} ៛
                      </td>
                      <td
                        className="title-table"
                        align="right"
                        style={{ color: "red" }}
                      >
                        $ {currencyFormat(row?.totalPriceAsUSD)}
                      </td>
                      <td
                        className="title-table"
                        align="right"
                        style={{ color: "blue" }}
                      >
                        {currencyFormatRiel(row?.priceKHR)} ៛
                      </td>
                      <td
                        className="title-table"
                        align="right"
                        style={{ color: "blue" }}
                      >
                        $ {currencyFormat(row?.priceUSD)}
                      </td>
                      {/* {row?.payments?.length === 0 ? (
                        <>
                          {largestPayments?.payments?.map(
                            (payment, subIndex) => {
                              console.log(
                                "payment::",
                                largestPayments?.payments?.length
                              );
                              return (
                                <Fragment key={subIndex}>
                                  <td className="title-table"></td>
                                  <td
                                    className="title-table"
                                    style={{ color: "red" }}
                                  >
                                    មិនបាន
                                  </td>
                                  <td className="title-table"></td>
                                  <td className="title-table"></td>
                                </Fragment>
                              );
                            }
                          )}
                        </>
                      ) : (
                        <>
                          {row?.payments?.map((payment, subIndex) => {
                            return (
                              <Fragment key={subIndex}>
                                <td className="title-table">
                                  {payment?.paymentMethod === "Bank"
                                    ? "ធនាគារ"
                                    : "សាច់ប្រាក់"}
                                </td>
                                <td className="title-table">បាន</td>
                                <td className="title-table"></td>
                                <td className="title-table"></td>
                              </Fragment>
                            );
                          })}
                        </>
                      )} */}
                      <td className="title-table">{row?.accountName}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {/* <Box sx={{ marginTop: "10px" }}>
              <Grid container spacing={0.5}>
                <Grid item xs={2.5}>
                  <Typography className="number-text">
                    ចំនួនទឹកប្រាក់រៀលជាអក្សរ ៖
                  </Typography>
                </Grid>
                <Grid item xs={9.5}>
                  <Typography className="number-text">
                    {ConvertToKhmerWordsRiel(totalPriceKHR)}
                  </Typography>
                </Grid>
                <Grid item xs={2.5}>
                  <Typography className="number-text">
                    Amount Riel in words ៖
                  </Typography>
                </Grid>
                <Grid item xs={9.5}>
                  <Typography className="number-text">
                    {ConvertToEnglishWordsRiel(totalPriceKHR)}
                  </Typography>
                </Grid>
                <Grid item xs={2.5}>
                  <Typography className="number-text">
                    ចំនួនទឹកប្រាក់ដុល្លាជាអក្សរ ៖
                  </Typography>
                </Grid>
                <Grid item xs={9.5}>
                  <Typography className="number-text">
                    {ConvertToKhmerWordsDollar(totalPriceUSD)}
                  </Typography>
                </Grid>
                <Grid item xs={2.5}>
                  <Typography className="number-text">
                    Amount Dollar in words ៖
                  </Typography>
                </Grid>
                <Grid item xs={9.5}>
                  <Typography className="number-text">
                    {ConvertToEnglishWordsDollar(totalPriceUSD)}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ marginTop: "20px" }}>
              <Grid container>
                <Grid item xs={4}>
                  <Stack direction="column" alignItems="center">
                    <Typography className="disbursement-table-title">
                      នាយិការង
                    </Typography>
                    <Typography
                      className="number-text"
                      style={{ fontWeight: "bold" }}
                    >
                      Deputy of School Principal
                    </Typography>
                    <Typography className="disbursement-table-title" mt={10}>
                      វេត ស្រីម៉ៅ
                    </Typography>
                    <Divider
                      style={{
                        width: "100px",
                        marginTop: "2px",
                        border: "1px solid rgba(15, 129, 194, 0.5)",
                      }}
                    />
                    <Typography className="number-text" mt={1}>
                      Date: .......................
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack direction="column" alignItems="center" mt={1}>
                    <Typography className="disbursement-table-title">
                      ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                    </Typography>
                    <Typography
                      className="number-text"
                      style={{ fontWeight: "bold" }}
                    >
                      Financial Affairs Director
                    </Typography>
                    <Typography className="disbursement-table-title" mt={10}>
                      ខូវ ស៊ូខេង
                    </Typography>
                    <Divider
                      style={{
                        width: "100px",
                        marginTop: "2px",
                        border: "1px solid rgba(15, 129, 194, 0.5)",
                      }}
                    />
                    <Typography className="number-text" mt={1}>
                      Date: .......................
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack direction="column" alignItems="center" mt={2}>
                    <Typography className="disbursement-table-title">
                      អ្នករៀបចំ
                    </Typography>
                    <Typography
                      className="number-text"
                      style={{ fontWeight: "bold" }}
                    >
                      Prepare by
                    </Typography>
                    <Typography className="disbursement-table-title" mt={10}>
                      ស៊ុន ផាត់សន
                    </Typography>
                    <Divider
                      style={{
                        width: "100px",
                        marginTop: "2px",
                        border: "1px solid rgba(15, 129, 194, 0.5)",
                      }}
                    />
                    <Typography className="number-text" mt={1}>
                      Date: .......................
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Box> */}
          </Box>
        </Box>
      </Box>
    </div>
  );
}
